module.exports = __webpack_public_path__ + "static/img/xiguan.27f58b4e.png";